import { useCallback } from "react";

import { useRequestFormSaveOrNull } from "@RequestFormV2/context/save";

export function usePersistDraft() {
  const saveContext = useRequestFormSaveOrNull();

  return useCallback((path?: string) => saveContext?.queueDraftSave(path), [saveContext]);
}
